import React from 'react';
import { StaticQuery, graphql } from 'gatsby';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import EssentialsPageStyle from './essentials-page.module.scss';

const HeroContent = () => (
  <StaticQuery
    query={graphql`
      query TheEssentialsQuery {
        contentfulTheEssentialsPage {
          essentialsReference {
            hero {
              headline {
                headline
              }
              paragraph {
                json
              }
            }
          }
        }
      }
    `}
    render={(data) => (
      <div className={EssentialsPageStyle.heroContentDiv}>
        <h1 className={EssentialsPageStyle.heroTitle}>
          {
            data.contentfulTheEssentialsPage.essentialsReference.hero.headline
              .headline
          }
        </h1>
        <div className={EssentialsPageStyle.heroDescription}>
          {documentToReactComponents(
            data.contentfulTheEssentialsPage.essentialsReference.hero.paragraph
              .json
          )}
        </div>

        <a
          href='https://app.firststringdigital.com/starter-monthly'
          className='hero-btn'
        >
          Start My Free Trial
        </a>
      </div>
    )}
  />
);

export default HeroContent;
